import { render, staticRenderFns } from "./healthAnalysis.vue?vue&type=template&id=65cbcc84&scoped=true&"
import script from "./healthAnalysis.vue?vue&type=script&lang=js&"
export * from "./healthAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./healthAnalysis.vue?vue&type=style&index=0&id=65cbcc84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbcc84",
  null
  
)

export default component.exports